const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"] || image;
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "eager";
  return newImage;
}

// Product data, fetched once per product and reused
const swatchProductCache = {};
const getSwatchProduct = (handle) => {
  if (!swatchProductCache[handle]) {
    swatchProductCache[handle] = fetch(window.Shopify.routes.root + `products/${handle}.js`)
      .then((response) => response.json())
      .catch(() => { delete swatchProductCache[handle]; return null; });
  }
  return swatchProductCache[handle];
}

// Main + hover image of a swatch value, loaded and decoded in advance
const swatchImageCache = {};
const prepareSwatchImages = (wrapper, value) => {
  const handle = wrapper.dataset.product;
  const key = handle + '|' + value;
  if (!swatchImageCache[key]) {
    swatchImageCache[key] = getSwatchProduct(handle).then((product) => {
      const primaryImage = wrapper.querySelector('.media--first');
      if (!product || !primaryImage) return null;
      const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(value))[0];
      if (!variant) return null;

      // Hover image = the media right after the variant's own image
      const media = product.media || [];
      const index = media.findIndex(item => item.id === variant["featured_media"].id);
      const next = index > -1 ? media[index + 1] : null;
      const nextIsVariantImage = next && product.variants.some(item => item.featured_media && item.featured_media.id === next.id);
      const hoverMedia = next && next.media_type === 'image' && !nextIsVariantImage ? next : null;

      const primary = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
      const hover = hoverMedia ? createImageElement(hoverMedia, 'motion-reduce media--second', primaryImage.sizes, product.title) : null;
      const ready = [primary.decode().catch(() => {})];
      if (hover) ready.push(hover.decode().catch(() => {}));
      return Promise.all(ready).then(() => ({ primary, hover }));
    });
  }
  return swatchImageCache[key];
}

// Preload the other finishes as soon as the pointer enters a card with swatches
const preloadCardSwatches = (wrapper) => {
  if (wrapper.dataset.swatchesPreloaded) return;
  wrapper.dataset.swatchesPreloaded = 'true';
  wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
    if (!input.checked) prepareSwatchImages(wrapper, input.value);
  });
}

const samePath = (a, b) => (a || '').split('?')[0].replace(/^https?:/, '') === (b || '').split('?')[0].replace(/^https?:/, '');

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    if (!wrapper.dataset.swatchesBound) {
      wrapper.dataset.swatchesBound = 'true';
      wrapper.addEventListener('pointerenter', () => preloadCardSwatches(wrapper));
      wrapper.addEventListener('touchstart', () => preloadCardSwatches(wrapper), { passive: true });
    }

    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      if (input.dataset.swatchBound) return;
      input.dataset.swatchBound = 'true';

      input.addEventListener('click', (event) => {
        const current = event.currentTarget;
        if (!current.checked || !wrapper.querySelector('.media--first')) return;

        wrapper.querySelector('.js-color-swatches-link').setAttribute('href', current.dataset.variantLink);
        if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
          wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
            wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
          }
          wrapper.querySelector('.card__add-to-cart input[name="id"]').value = current.dataset.variantId;
        }

        prepareSwatchImages(wrapper, current.value).then((prepared) => {
          if (!prepared || !current.checked) return;
          const primaryImage = wrapper.querySelector('.media--first');
          const secondaryImage = wrapper.querySelector('.media--second');
          if (!primaryImage || samePath(primaryImage.currentSrc || primaryImage.src, prepared.primary.src)) return;

          // Images are already loaded: swap at once, with a short fade
          const newPrimary = prepared.primary.cloneNode(true);
          primaryImage.replaceWith(newPrimary);
          newPrimary.animate({ opacity: [0.4, 1] }, { duration: 150, easing: "ease-out" });

          if (prepared.hover) {
            const newSecondary = prepared.hover.cloneNode(true);
            if (secondaryImage) secondaryImage.replaceWith(newSecondary); else newPrimary.after(newSecondary);
          } else if (secondaryImage) {
            secondaryImage.remove();
          }
        });
      });
    });
  });
}

function colorSwatches() {
  checkSwatches();
}

document.addEventListener('shopify:section:load', function () {
  checkSwatches();
});

// Hover image only while the pointer is over the picture, not over title, price or swatches
(function () {
  let lastCard = null;
  document.addEventListener('pointermove', (event) => {
    const card = event.target.closest ? event.target.closest('.js-color-swatches-wrapper') : null;
    if (lastCard && lastCard !== card) lastCard.classList.remove('card-no-hover');
    lastCard = card;
    if (!card) return;
    const media = card.querySelector('.media');
    if (!media) return;
    card.classList.toggle('card-no-hover', event.clientY > media.getBoundingClientRect().bottom);
  }, { passive: true });
})();

(function () {
colorSwatches();
})()
